import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { EmailTemplate } from "../../shared/EmailViewTemplate";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";

interface IProps {
    toast?: any
}

interface IEmailToView {
    name?: string,
    email?: string,
    subject?: string,
    emailBody?: string,
    emailDate?: any,
    messageID?: string,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmailToView>, loading: boolean });
    const [reload, setReload] = useState<boolean>(false);
    const [emailBodyModal, setEmailBodyModal] = useState({ open: false, data: {} } as { open: boolean, data: IEmailToView });
    const [filters, setFilters] = useState<string>("");

    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => setReload(!reload)} />
            </React.Fragment>
        );
    }

    const rightToolbarTemplate = () => {
        return (
            <>
            </>
        );
    }

    const header = () => {
        return (
            <>
            </>
        );
    }

    const actionBodyTemplate = () => {
        return (
            <>
            </>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InboxEmail/inboxEmails", "GET", null, null, props.toast);
        if (response) {
            const data: IEmailToView[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const onHide = () => {
        setEmailBodyModal({ open: false, data: {} });
    }

    useEffect(() => {
        loadTableData();
    }, [reload]);

    return (
        <>
            {/* <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: string) => setFilters(filters)} />
                </AccordionTab>
            </Accordion> */}
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                emptyMessage="No Pages found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="name" header="Name" sortable body={(rowData: IEmailToView) => <span>{rowData.name?.trim().split('"')[1]}</span>} />
                <Column field="email" header="Email" sortable body={(rowData: IEmailToView) => <span>{rowData.email?.trim().split(">")[0]}</span>} />
                <Column field="subject" header="Subject" />
                <Column field="emailDate" header="Date" body={(rowData: any) => {
                    let data: Date = new Date(rowData?.emailDate);
                    return <span>{data.toDateString()}</span>;
                }} />
                <Column header="Body" body={(rowData: any) => <p className="underline text-blue-400" style={{ cursor: "pointer" }} onClick={() => setEmailBodyModal({ open: true, data: rowData })}>body</p>} />
                <Column field="messageID" header="Message-ID" body={(rowData: any) => {
                    let data: string = rowData.messageID?.split("Message-Id: ")[1]?.split("\r\nTo:")[0]?.split("<")[1]?.split(">")[0];
                    return <span>{data}</span>;
                }} />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <Dialog visible={emailBodyModal.open} style={{ width: '80vw' }} header="Email Body" className="p-fluid" maximizable onHide={onHide}>
                <p>{emailBodyModal.data.emailBody}</p>
                <EmailTemplate
                    email={emailBodyModal.data.email}
                    name={emailBodyModal.data.name}
                    emailDate={new Date(emailBodyModal.data.emailDate)}
                    subject={emailBodyModal.data.subject}
                    body={emailBodyModal.data.emailBody}
                />
            </Dialog>
        </>
    )
}